const htmlToElement = <T extends Element>(html: string): T | null => {
  if (!html) return null;
  const template = document.createElement("template");
  template.innerHTML = html.trim();
  // we only want the first child, this removes a possible script tag from the oembed response
  return template.content.firstElementChild as T;
};

export default htmlToElement;
